import escape from 'lodash-es/escape';

/**
 * Generates the root type to use as a param for filtering by a custom row.
 */
export const getCustomRowRootType = (
  featuredCategory: string,
  storeId: number
) => `${escape(featuredCategory)}-${storeId}`;
